import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'
export default class SoftFixedEmergency extends CosmosJobsDbRecordBase {
  public title: string
  public description: string
  public softFixedBy: string
  public emergencyId: string
}
